// extracted by mini-css-extract-plugin
module.exports = {"spinner":"styles_spinner__Vor_U","rotating":"styles_rotating__cJC1P"};